import { useTranslation } from 'react-i18next';
import { SegmentedControl } from '~/components/segmented-control';
import { Field } from '~/components/promotion/editor-section';
import { TierFields } from './tier-fields';
import type { PromotionAction } from '~/lib/schemas/actions';

type Action = Extract<PromotionAction, { type: 'value-discount' }>;

interface Props {
	value: Action;
	onChange: (next: Action) => void;
}

/** Only the value (Αξιακή) action has the once/per-item application mode. */
export function ValueDiscountBody({ value, onChange }: Props) {
	const { t } = useTranslation();
	return (
		<div className="flex flex-col gap-4">
			<Field label={t('promotion.action.applicationMode.label')} help={t('promotion.action.applicationMode.help')}>
				<SegmentedControl
					value={value.applicationMode}
					onValueChange={applicationMode => onChange({ ...value, applicationMode })}
					options={[
						{ value: 'once', label: t('promotion.action.applicationMode.once') },
						{ value: 'perItem', label: t('promotion.action.applicationMode.perItem') }
					]}
				/>
			</Field>
			<TierFields value={value} onChange={tf => onChange({ ...value, ...tf })} valueLabel="amount" />
		</div>
	);
}
